import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { updateEditAction } from '@/main/store/actionsFunctions';
import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';
import _ from 'lodash';

import { NAME as name, CRUMB_LABEL_KEY, DEPENDENT_TABLES, MERGE_ZAKAZNIK, MERGE_VOZIDLO, PHOTO_LIST, PENDING_JOB_LIST } from '../constants';
import { apiProvider } from '../api';
import { editMutations, actions } from './types';

export interface CheckboxItem {
	Acces: boolean,
	Text: string,
	VybCheckbox: boolean,
	ZvlnabidkaOzn: string,
}

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		ChiscenarId: [],
		InterstavPzn: [],
		ExterstavPzn: [],
	},
	edit: {
		CheckinId: null as number | null,
		ProvozovnaId: null as number | null,
		VozidloId: null as number | null,
		ZakaznikId: null as number | null,
		VozidlokonId: null as number | null,
		ZakaznikkonId: null as number | null,
		KmStav: null as number | null,
		PalivoStav: null as number | null,
		VrJmenoPrijm: null as string | null,
		ServknizPrp: null as number | null,
		OtpPrp: null as number | null,
		PojistpriPrp: null as number | null,
		StkplatDat: null as string | null,
		PristiEkDat: null as string | null,
		Poznamka: null as string | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		DeviceId: null as string | null,
		EditDat: null as string | null,
		EditPracId: null as number | null,
		OzakazkaId: null as number | null,
		ChiscenarId: null as number | null,
		UzavreniDat: null as string | null,
		TiskDat: null as string | null,
		PoznamkaZl: null as string | null,
		InterstavPzn: null as number | null,
		ExterstavPzn: null as number | null,
		CheckinNr: null as number | null,
		MiddlewarePrp: null as number | null,
		MiddlewareCheckinId: null as number | null,
		ObchPripadId: null as number | null,
		PchiObchodnikNr: null as string | null,
		VrEMailAdresa: null as string | null,
		VrTelNr: null as string | null,
		Vybava: [] as CheckboxItem[],
		PovinVybava: [] as CheckboxItem[],
		Sluzby: [] as CheckboxItem[],
		ZvlNabidky: [] as CheckboxItem[],
		ZakaznikIdText: null as string | null,
		ZakaznikkonIdText: null as string | null,
		VozidloIdSpz: null as string | null,
		KaroserieNr: null as string | null,
		VozidlokonIdSpz: null as string | null,
		VozidloIdText: null as string | null,
		VozidlokonIdText: null as string | null,
		IsCustRevisit: null as boolean | null,
		// vazba 1:N, teoreticky muze k jednomu checkinu existovat vice zakazek
		Zakazky: [] as { ZakazkaId: number, ZakazkaNr: number }[],
		WatchlistFlag: false as boolean | null,
		NotificationMessage: null as string | null,
		CategoryName: null as string | null,
		WatchlistDialog: false as boolean | null,
		EnableRegionFlag: null as boolean | null,
		EnableRegionFlagForWatchlisted: null as boolean | null,
		IsWatchlistedVehicle: false as boolean | null,
		Remarks: null as string | null,
		IsCustomerFirstVisit: null as boolean | null,
		FirstVisitVisible: false as boolean | false,
		CustFirstVisitPrp: false as boolean | false,
		ZakazkaDruh: null as string | null,
	},
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[PHOTO_LIST]: {
			filter(state) {
				return {
					middlewareCheckinId: state.edit.MiddlewareCheckinId,
					pchiObchodnikNr: state.edit.PchiObchodnikNr,
				};
			},
		},
		[MERGE_ZAKAZNIK]: {
			filter(state) {
				return {
					...(state.edit.ZakaznikkonId && { ZakaznikkonId: state.edit.ZakaznikkonId }),
				};
			},
		},
		[MERGE_VOZIDLO]: {
			filter(state) {
				return {
					...(state.edit.VozidlokonId && { VozidlokonId: state.edit.VozidlokonId }),
				};
			},
		},
		[PENDING_JOB_LIST]: {
			filter(state) {
				if (state.edit.VozidloId) {
					return {
						VozidloId: state.edit.VozidloId,
					};
				}
				return {};
			},
		},
	},
	localState: {
		ShowDialogPendingJoblist: false as boolean | false,
	},
	extraActions: {
		[actions.VOZIDLO_CHANGE]: async ({ commit, state, dispatch }) => {
			if (state.edit.EnableRegionFlag) {
				const customerFirstVisitDetails = await updateEditAction(
					state,
					commit,
					dispatch,
					zakazkaApiProvider.customerFirstVisitCheck(state.edit.VozidloId ? state.edit.VozidloId : 0),
				);
				if (customerFirstVisitDetails.data) {
					commit(editMutations.VOZIDLO_CHANGE, customerFirstVisitDetails);
				}
			}
			await dispatch(`${PENDING_JOB_LIST}_TABLE_DATA`, { filter: { VozidloId: state.edit.VozidloId } });

			const zakazka = await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.vozidloChange(state.edit),
			);
			state.localState.ShowDialogPendingJoblist = true;
			state.edit.ZakaznikId = zakazka.data.ZakaznikId;
			state.edit.ZakaznikIdText = zakazka.data.ZakaznikIdText;
		},
	},
	extraGetters: {},
	extraMutations: {
		async [editMutations.VOZIDLO_SELECT_MAPPER](state, { data }) {
			state.edit.VozidloId = data.value;
			state.edit.VozidloIdSpz = data.spz;
			state.edit.VozidlokonId = null;
			state.edit.VozidlokonIdSpz = null;
			state.edit.VozidlokonIdText = null;
			state.edit.KaroserieNr = data.karoserieNr;
			if (state.edit.EnableRegionFlagForWatchlisted) {
				const data2 = await apiProvider.isWatchlistedVIN(data.karoserieNr);
				if (data2.data.WatchlistFlag === true) {
					state.edit.WatchlistFlag = true;
					state.edit.WatchlistDialog = true;
					state.edit.NotificationMessage = data2.data.NotificationMessage;
				}
			}
		},
		[editMutations.PARTNER_SELECT_MAPPER](state, { data }) {
			state.edit.ZakaznikId = data.value;
			state.edit.ZakaznikIdText = data.isClear ? null : data.text;
			state.edit.ZakaznikkonId = null;
			state.edit.ZakaznikkonIdText = null;
			if (data.IsCustomerFirstVisit) {
				state.edit.CustFirstVisitPrp = true;
				state.edit.IsCustomerFirstVisit = true;
			} else {
				state.edit.CustFirstVisitPrp = false;
			}
		},
		[editMutations.VOZIDLO_CHANGE](state, { data }) {
			if (data.IsCustomerFirstVisit) {
				state.edit.CustFirstVisitPrp = true;
			} else {
				state.edit.CustFirstVisitPrp = false;
			}
		},
		[editMutations.CREATED_ZAKAZKA](state, data) {
			if (!_.some('ZakazkaId', data.ZakazkaId)) {
				state.edit.Zakazky.push({
					ZakazkaId: data.ZakazkaId,
					ZakazkaNr: data.ZakazkaNr,
				});
			}
		},
		[editMutations.UPDATE_CHECKIN_AFTER_MERGE](state, data) {
			if (data.ZakaznikId) {
				state.edit.ZakaznikId = data.ZakaznikId;
				state.edit.ZakaznikIdText = data.Jmeno ? `${data.Jmeno} ${data.Text}` : data.Text;
				state.edit.ZakaznikkonId = null;
				state.edit.ZakaznikkonIdText = null;
			} else if (data.VozidloId) {
				state.edit.VozidloId = data.VozidloId;
				state.edit.VozidloIdText = data.KaroserieNr;
				state.edit.VozidloIdSpz = data.Spz;
				state.edit.VozidlokonId = null;
				state.edit.VozidlokonIdSpz = null;
				state.edit.VozidlokonIdText = null;
			}
		},
	},
	props: {
		mode: null,
	},
});
